module.exports = __webpack_public_path__ + "img/quiz-bg.621e0f0.png";